import { Component } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import { trackEvent } from 'dibs-tracking';
import { getUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers';

import contactDealerLauncher from 'dibs-buyer-layout/exports/contactDealerLauncher';
import { getQueryParam } from '../utils/uriUtils';
import { getFdfQuoteABTestVariant } from 'dibs-buyer-layout/src/helpers/getFdfQuoteABTestVariant';

class SharedContactDealerWrapperComponent extends Component {
    constructor(props) {
        super(props);
        this.doRefetch = this.doRefetch.bind(this);
        this.onContactClick = this.onContactClick.bind(this);
    }

    componentDidMount() {
        const queryParams = get(global, 'location.search');
        const modalParam = getQueryParam(queryParams, 'modal');
        if (
            this.props.loadOnMount ||
            (this.props.modalType === 'CONTACT_DEALER' && modalParam === 'contact-dealer') ||
            (this.props.modalType === 'REQUEST_CUSTOMIZATION' &&
                modalParam === 'request-customization')
        ) {
            this.onContactClick(null);
        }
    }

    doRefetch(refetchVariables) {
        const variables = {
            ...refetchVariables,
            fdfQuoteABTestVariant: getFdfQuoteABTestVariant(),
            userCountryCode: getUserSessionCountryCode(),
            itemQuantity: this.props?.itemQuantity,
        };
        this.props.relay.refetch(variables);
    }

    onContactClick(event) {
        const {
            relay,
            item,
            selectedSkuId,
            launchOrigin,
            modalType,
            user,
            currency,
            itemQuantity,
        } = this.props;
        trackEvent(
            {
                category: 'contact dealer',
                action: 'contact dealer clicked',
                label: launchOrigin,
                eventName: 'contact',
                step_interaction_name: 'entry',
                interaction_type: 'contact dealer',
                trigger: launchOrigin,
            },
            event
        );

        contactDealerLauncher({
            environment: relay.environment,
            itemId: item.serviceId,
            selectedSkuId,
            launchOrigin,
            modalType,
            currency: currency,
            userId: (user && user.serviceId) || null,
            onSuccessfulShippingQuoteRequest: this.doRefetch,
            itemQuantity,
        });
    }

    render() {
        const { children } = this.props;

        return <div data-tn="contact-dealer-wrapper-cta">{children(this.onContactClick)}</div>;
    }
}

SharedContactDealerWrapperComponent.propTypes = {
    children: PropTypes.func,
    item: PropTypes.object.isRequired,
    selectedSkuId: PropTypes.string,
    launchOrigin: PropTypes.string.isRequired,
    loadOnMount: PropTypes.bool,
    modalType: PropTypes.oneOf([
        'CONTACT_DEALER',
        'REQUEST_CUSTOMIZATION',
        'REQUEST_PRICE',
        'REQUEST_IMAGES',
        'REQUEST_IMAGES_AND_VIDEOS',
        'DESIGN_YOUR_OWN',
    ]),
    relay: PropTypes.object.isRequired,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
    itemQuantity: PropTypes.number,
};

SharedContactDealerWrapperComponent.defaultProps = {
    loadOnMount: false,
    modalType: 'CONTACT_DEALER',
};

SharedContactDealerWrapperComponent = SharedContactDealerWrapperComponent;

export const SharedContactDealerWrapper = createRefetchContainer(
    SharedContactDealerWrapperComponent,
    {
        item: graphql`
            fragment SharedContactDealerWrapper_item on Item {
                serviceId
            }
        `,
        user: graphql`
            fragment SharedContactDealerWrapper_user on User {
                serviceId
            }
        `,
    },
    graphql`
        query SharedContactDealerWrapperRefetchQuery(
            $userId: String!
            $itemId: String!
            $userZipCode: String = ""
            $userCountryCode: String = ""
            $isClient: Boolean!
            $fetchUser: Boolean!
            $itemQuantity: Int
            $fdfQuoteABTestVariant: String
        ) {
            viewer {
                ...PdpRespSidebarBlurbShipping_viewer
                ...PdpSharedShippingHolidayDelivery_viewer
                ...PdpSharedShippingInfoLink_viewer
                relevantShipping(
                    itemId: $itemId
                    buyerId: $userId
                    quantity: $itemQuantity
                    zipCode: $userZipCode
                    countryCode: $userCountryCode
                    fdfQuoteABTestVariant: $fdfQuoteABTestVariant
                ) {
                    quoteRequestStatus
                    shipmentQuote {
                        ...PdpSharedShippingInfoLink_shipmentQuote
                        handlingTimeDisplay(displayShort: true)
                        subTotalAmount {
                            convertedAmountList {
                                currency
                                amount
                            }
                        }
                        buyerServiceMethodDisplay
                        showQuoteAsPending
                        serviceMethod {
                            serviceType
                            serviceMethodType
                        }
                    }
                    shipment {
                        shippingAddress {
                            displayCityStateCountry
                        }
                    }
                }
            }
        }
    `
);
